var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { convertVariantIdToGlobalId, convertGlobalIdToRawId, transformTagsIntoProperties, GraphQL } from '@bombas/shopify';
import { defineEvent } from '../types/event';
export var CART_ADD = defineEvent({
    enhance: function (input_1, _a) { return __awaiter(void 0, [input_1, _a], void 0, function (input, _b) {
        var _c, variantData, cartData, params;
        var apolloClient = _b.apolloClient;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        apolloClient.query({
                            query: GraphQL.PRODUCT_VARIANT,
                            variables: {
                                productVariantId: convertVariantIdToGlobalId(input.variantId)
                            },
                            context: { service: 'storefront' }
                        }),
                        apolloClient.query({
                            query: GraphQL.CART,
                            variables: {
                                cartId: input.cart.id,
                                country: input.cart.country
                            },
                            context: { service: 'storefront' }
                        })
                    ])];
                case 1:
                    _c = _d.sent(), variantData = _c[0].data.node, cartData = _c[1].data.cart;
                    params = new URLSearchParams();
                    variantData.selectedOptions.forEach(function (_a) {
                        var name = _a.name, value = _a.value;
                        params.append(name.toLowerCase() === 'color' ? 'variant' : name, value);
                    });
                    return [2 /*return*/, Promise.resolve({
                            variant: variantData,
                            variantUrl: "/products/".concat(variantData.product.handle, "?").concat(params),
                            cart: cartData
                        })];
            }
        });
    }); },
    platforms: [
        {
            name: 'GTM',
            transform: function (input, _a) {
                var _b;
                var variant = _a.variant, variantUrl = _a.variantUrl;
                return {
                    eventName: 'addToCart',
                    product: {
                        json: {
                            id: convertGlobalIdToRawId(variant.product.id),
                            title: variant.product.title,
                            price: parseFloat(variant.priceV2.amount) * 100,
                            type: variant.product.productType,
                            pdpLink: variantUrl
                        }
                    },
                    variant: {
                        id: input.variantId,
                        quantity: input.quantity,
                        sku: variant.sku,
                        pdpLink: variantUrl
                    },
                    ecommerce: {
                        items: [
                            {
                                item_id: convertGlobalIdToRawId(variant.product.id),
                                item_name: variant.product.title,
                                affiliation: 'Bombas',
                                currency: variant.priceV2.currencyCode,
                                item_category: variant.product.productType,
                                item_category2: (_b = transformTagsIntoProperties(variant.product.tags).gender) === null || _b === void 0 ? void 0 : _b[0],
                                item_brand: 'Bombas',
                                item_variant: variant.title,
                                price: parseFloat(variant.priceV2.amount),
                                quantity: input.quantity
                            }
                        ]
                    }
                };
            }
        },
        {
            name: 'Heap',
            transform: function (input, _a) {
                var _b, _c;
                var variant = _a.variant, cart = _a.cart;
                return ({
                    eventName: 'cartAdd',
                    productId: convertGlobalIdToRawId(variant.product.id),
                    productName: variant.product.title,
                    productCategory: variant.product.productType,
                    productQuantity: input.quantity,
                    productPrice: parseFloat(variant.priceV2.amount),
                    shopifyCartId: convertGlobalIdToRawId(cart.id),
                    cartSubtotal: cart.cost.subtotalAmount.amount,
                    cartRevenue: cart.cost.totalAmount.amount,
                    cartCouponCode: (_c = (_b = cart.discountCodes) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code,
                    cartCurrency: cart.cost.totalAmount.currencyCode,
                    cartCreatedAt: cart.createdAt,
                    source: input.source
                });
            }
        },
        {
            name: 'Optimizely',
            transform: function () { return ({
                eventName: 'Add_to_Cart'
            }); }
        }
    ]
});
